<template>
    <Card class="my-4 relative overflow-hidden" :class="{ 'border border-yellow-300' : selected}">
      <span class="absolute -left-6 top-3 transform -rotate-45 w-24 text-center bg-yellow-300 p-1 text-xs"
            v-if="selected">فعال </span>
      <div class="flex items-center justify-between">
        <div class="text-gray-500 text-sm">
          <div class="flex items-center mt-3">
            
            <span class="mr-1 flex" >{{ name }}</span>
          </div>
        </div>
        <div class="mb-2"><!--:value="`${baseurl}/shop/${this.$store.getters.slug}/menu/${id}`"-->
          <QRCodeVue3
            :value="`${baseurl}/shop/${this.$store.getters.slug}/menu/${id}`"
            :width="200"
            :height="200"
            :qrOptions="{ typeNumber: '0', mode: 'Byte', errorCorrectionLevel: 'Q' }"
            :imageOptions="{ hideBackgroundDots: true, imageSize: 0.4, margin: 0 }"
            :dotsOptions="{ type: 'square', color: '#05004d' }"
            :cornersSquareOptions="{ type: 'square', color: '#0e013c' }"
            
          />
          
        </div>

        <!--<qr-code  :text="`${baseurl}/shop/${this.$store.getters.slug}/menu/${id}`"  bg-color="#3498db" class="w-52 h-52"  ></qr-code>-->
      </div>
      <span class="bg-green-300 rounded-xl w-20 mr-36 box-border text-xl px-5">
          <button @click="OpenCustomerApp" class="text-xl ">   کلیک کنید   </button>
      </span>

      <hr class="mt-1">
      <div class="flex justify-between">
        <router-link :to="`/menu/edit/${id}`" class="bg-yellow-300 rounded-xl p-2 mt-2 px-5 text-xs">ویرایش
        </router-link>
        <router-link :to="`/menu/${id}`" class="bg-yellow-300 rounded-xl px-6 p-2 mt-2 text-xs">گروهها({{ catCount }})
        </router-link>
        <button class="bg-red-400 rounded-xl px-6 p-2 mt-2 text-xs text-gray-100" @click="deleteMenu">حذف</button>
      </div>
    </Card>
  
  
  </template>
  <script>
  import Card from "@/components/General/VCard"
  import QRCodeVue3 from "qrcode-vue3";
  // import {deleteAddress} from "@/API/User";
  
  export default {
    props: ['id', 'name','catCount','baseurl','selected'],
    name: 'MenuCard',
    emits: ['deleted'],
    components: {Card,QRCodeVue3},
    methods: {
      OpenCustomerApp() {
        //console.log('1');
        //window.open(`${this.baseurl}/shop/${this.$store.getters.slug}/menu/${this.id}`, '_blank');
        console.log('${this.baseurl}/shop/${this.$store.getters.slug}/menu');
        window.open(`${this.baseurl}/shop/${this.$store.getters.slug}/menu/${this.id}`, '_blank');

    },
      deleteMenu() {
        this.$emit('deleted', this.id)
      }
    }
  }
  </script>
  